import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Blog() {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'جميع المقالات' },
    { id: 'business', name: 'إدارة الأعمال' },
    { id: 'tech', name: 'التقنية' },
    { id: 'marketing', name: 'التسويق' },
    { id: 'hr', name: 'الموارد البشرية' }
  ];

  const articles = [
    {
      id: 1,
      title: 'كيف تبني استراتيجية عمل ناجحة في 2024',
      category: 'business',
      excerpt: 'دليل شامل لبناء استراتيجية عمل فعالة تساعدك على تحقيق أهدافك وتطوير مؤسستك',
      image: 'https://public.readdy.ai/ai/img_res/e89a42f5b06a0cb00cb6fd6ccad8aa22.jpg',
      author: 'مصطفى محمد',
      date: '15 يناير 2024',
      readTime: '8 دقائق'
    },
    {
      id: 2,
      title: 'التحول الرقمي: خطوات عملية للمؤسسات',
      category: 'tech',
      excerpt: 'تعرف على الخطوات الأساسية للتحول الرقمي الناجح وكيف تستفيد منه مؤسستك',
      image: 'https://readdy.ai/api/search-image?query=digital%20transformation%20with%20modern%20technology%20and%20innovative%20systems%2C%20clean%20minimalist%20background%2C%20professional%20tech%20environment%2C%20high%20quality%20photography&width=800&height=500&seq=blog2&orientation=landscape',
      author: 'أحمد السعيد',
      date: '12 يناير 2024',
      readTime: '10 دقائق'
    },
    {
      id: 3,
      title: 'استراتيجيات التسويق الرقمي الفعالة',
      category: 'marketing',
      excerpt: 'أفضل الممارسات والاستراتيجيات لتحقيق نتائج متميزة في التسويق الرقمي',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20strategy%20with%20social%20media%20and%20analytics%2C%20clean%20modern%20background%2C%20professional%20marketing%20workspace%2C%20high%20quality%20photography&width=800&height=500&seq=blog3&orientation=landscape',
      author: 'فاطمة الزهراني',
      date: '10 يناير 2024',
      readTime: '7 دقائق'
    },
    {
      id: 4,
      title: 'تطوير الموارد البشرية في العصر الحديث',
      category: 'hr',
      excerpt: 'كيف تبني فريق عمل متميز وتطور مهارات موظفيك بشكل مستمر',
      image: 'https://readdy.ai/api/search-image?query=HR%20development%20and%20team%20training%20in%20modern%20workplace%2C%20clean%20bright%20background%2C%20professional%20corporate%20environment%2C%20high%20quality%20photography&width=800&height=500&seq=blog4&orientation=landscape',
      author: 'خالد المطيري',
      date: '8 يناير 2024',
      readTime: '9 دقائق'
    },
    {
      id: 5,
      title: 'الذكاء الاصطناعي في الأعمال',
      category: 'tech',
      excerpt: 'كيف يمكن للذكاء الاصطناعي أن يحدث ثورة في طريقة عمل مؤسستك',
      image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20in%20business%20with%20futuristic%20technology%2C%20clean%20minimalist%20background%2C%20professional%20tech%20environment%2C%20high%20quality%20photography&width=800&height=500&seq=blog5&orientation=landscape',
      author: 'مصطفى محمد',
      date: '5 يناير 2024',
      readTime: '12 دقيقة'
    },
    {
      id: 6,
      title: 'بناء ثقافة مؤسسية قوية',
      category: 'business',
      excerpt: 'الخطوات الأساسية لبناء ثقافة مؤسسية تدعم النمو والابتكار',
      image: 'https://readdy.ai/api/search-image?query=corporate%20culture%20with%20diverse%20team%20collaboration%2C%20clean%20bright%20background%2C%20professional%20business%20environment%2C%20high%20quality%20photography&width=800&height=500&seq=blog6&orientation=landscape',
      author: 'سارة العتيبي',
      date: '3 يناير 2024',
      readTime: '6 دقائق'
    }
  ];

  const filteredArticles = activeCategory === 'all' 
    ? articles 
    : articles.filter(a => a.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h1 className="text-5xl font-bold mb-6">المدونة</h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              مقالات ونصائح متخصصة في مجالات الأعمال والتقنية والتطوير المؤسسي
            </p>
          </div>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="py-12 bg-gray-50 sticky top-0 z-40 shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category.id
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.map((article, index) => (
              <article 
                key={article.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative h-64 w-full overflow-hidden">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 right-4">
                    <span className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold">
                      {categories.find(c => c.id === article.category)?.name}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h2 className="text-xl font-bold text-gray-800 mb-3 leading-tight hover:text-blue-600 transition-colors">
                    <Link to={`/blog/${article.id}`} className="cursor-pointer">{article.title}</Link>
                  </h2>
                  <p className="text-gray-600 leading-relaxed mb-4">{article.excerpt}</p>
                  
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-full">
                        <i className="ri-user-line text-blue-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-gray-800">{article.author}</div>
                        <div className="text-xs text-gray-500">{article.date}</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 text-gray-500 text-sm">
                      <i className="ri-time-line"></i>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                  
                  <Link 
                    to={`/blog/${article.id}`}
                    className="inline-flex items-center gap-2 text-blue-600 font-semibold mt-4 hover:gap-3 transition-all cursor-pointer"
                  >
                    <span>اقرأ المزيد</span>
                    <i className="ri-arrow-left-line"></i>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h2 className="text-4xl font-bold mb-6">اشترك في نشرتنا البريدية</h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              احصل على أحدث المقالات والنصائح مباشرة في بريدك الإلكتروني
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
              <input
                type="email"
                placeholder="أدخل بريدك الإلكتروني"
                className="flex-1 px-6 py-4 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-white text-sm"
              />
              <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                اشترك الآن
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}